// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ViewPortCallReport\ViewPortCallReportViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';

// PortCallReportData is the class that PortCallReport serializes to/from
export interface PortCallReportData {
    PortCallId : number;
	
    CurrentPC : PortCallData | null;
	
}

// PortCallReportOptions is the class which may be passed to the PortCallReport constructor to define optional initial data values
export interface PortCallReportOptions {
    PortCallId : number;
	
    CurrentPC? : PortCallOptions | null;
	
}

export class PortCallReport {
    public PortCallId : DataSignal<number>;
	
    public CurrentPC : DataSignal<PortCall | null>;
	

    constructor();
    constructor(data : PortCallReportOptions);
    constructor(data: PortCallReportOptions | null = null) {
        this.PortCallId = jsonableObservable(S.value<number>(data && data.PortCallId !== undefined ? data.PortCallId : 0));
	    
        this.CurrentPC = S.value<PortCall | null>(null);
	    
    }

    static key(obj : PortCallReport) {
        return obj.PortCallId();
    }
    
    static dataKey(obj : PortCallReportOptions) {
        return obj.PortCallId;
    }

    static update(obj : PortCallReport, data : PortCallReportOptions) {
        S.freeze(() => {
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PortCallReport.ts